import { ENV_DEV } from "../window";
import joinRGBA from "./join-rgba";

/**
 *
 * @param {String} hex
 * @param {String} separator
 * @returns {String}
 */
const hexToRgba = (hex, separator) => {
  /** Handle shorthand (3-character HEX) */
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  /** Handle HEX with alpha (8 characters) */
  if (hex.length === 8) {
    return joinRGBA(hex, true, separator);
  }

  /** Handle regular 6-character HEX */
  if (hex.length === 6) {
    return joinRGBA(hex, false, separator);
  }

  if (ENV_DEV) {
    console.warn(`[TorusKit warn]: Invalid HEX color format: ${hex}`);
  }

  return hex;
};

export default hexToRgba;
